// src/Tiptap.tsx
import { useEditor, EditorContent } from "@tiptap/react";
import StarterKit from "@tiptap/starter-kit";
import { BulletList, ListItem } from "@tiptap/extension-list";
import { Box, Button, ButtonGroup } from "@mui/material";
import { FormatListBulleted } from "@mui/icons-material";

const Tiptap = ({ editable = true, editorContent, onChange }) => {
  const editor = useEditor({
    // Example:
    // extensions: [StarterKit], // define your extension array
    // content: "<p>Hello World!</p>", // initial content

    // Copy from CFI
    // extensions: [StarterKit],
    extensions: [StarterKit, BulletList, ListItem],
    content: editorContent ?? "",
    // Don't render immediately on the server to avoid SSR issues
    immediatelyRender: false,
    editable,
    onUpdate({ editor }) {
      // The content has changed.

      let htmlValue = editor.getHTML();
      let jsonValue = editor.getJSON();
      let textValue = editor.getText();
      // console.log("Tiptap onUpdate", htmlValue, jsonValue, textValue);
      onChange(htmlValue, jsonValue, textValue);
    },
  });

  if (!editor) {
    return null;
  }

  return (
    <Box sx={{ flex: 1, width: "100%" }}>
      {editable && (
        <Box
          sx={{
            display: "flex",
            alignItems: "flex-end",
            justifyContent: "flex-end",
          }}
        >
          <ButtonGroup>
            <Button
              variant="outlined"
              onClick={() => editor.chain().focus().toggleBulletList().run()}
              className={editor.isActive("bulletList") ? "is-active" : ""}
            >
              <FormatListBulleted />
            </Button>
          </ButtonGroup>
        </Box>
      )}

      <Box sx={{ border: 1, padding: "16px" }}>
        <EditorContent editor={editor} />
      </Box>
    </Box>
  );
};

export default Tiptap;
